import { IDesqualified, ILabelValue } from "shared/types";

export const dataFake: ILabelValue[] = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
];

export const desqualifiedData: IDesqualified[] = [
  {
    name: "Roberto Silva",
    fantasyName: "Beto Trading",
    dateDesqualified: "2024-04-01",
    type: "Hospital Público",
    sub: {
      name: "Carlos Martins",
      fantasyName: "Carlinhos Investments",
      dateDesqualified: "2024-04-02",
      type: "Hospital Privado",
    },
  },
  {
    name: "Maria Clara",
    fantasyName: "Clara Tech",
    dateDesqualified: "2024-03-01",
    type: "Hospital Universitário",
    sub: {
      name: "Lucas Mendes",
      fantasyName: "Mendes Pharma",
      dateDesqualified: "2024-03-02",
      type: "Hospital de Especialidades",
    },
  },
  {
    name: "Fernanda Gomes",
    fantasyName: "Nanda Systems",
    dateDesqualified: "2024-05-01",
    type: "Hospital Pediátrico",
    sub: {
      name: "Tiago Ramos",
      fantasyName: "Ramos Care",
      dateDesqualified: "2024-05-02",
      type: "Hospital Geriátrico",
    },
  },
  {
    name: "Eduardo Sampaio",
    fantasyName: "Du Educação",
    dateDesqualified: "2024-06-01",
    type: "Hospital Oncológico",
    sub: {
      name: "Ana Paula",
      fantasyName: "Ana Health",
      dateDesqualified: "2024-06-02",
      type: "Hospital Cardiológico",
    },
  },
  {
    name: "Juliana Morais",
    fantasyName: "Ju BioTech",
    dateDesqualified: "2024-07-01",
    type: "Hospital de Clínica Geral",
    sub: {
      name: "Sérgio Lopes",
      fantasyName: "Sergio Diagnostic",
      dateDesqualified: "2024-07-02",
      type: "Hospital Neurologico",
    },
  },
];
